import type { TruncationMode } from '@dynatrace/strato-components/typography';

import { getHorizontalMeasurements } from '../../../../core/utils/get-horizontal-measurements.js';
import { isInHorizontalBounds } from '../../../../core/utils/is-in-horizontal-bounds.js';
import { truncateText } from '../../../../core/utils/text-truncation.js';
import {
  HONEYCOMB_LABEL_FONT_SIZE,
  HONEYCOMB_VALUE_LABEL_FONT_SIZE,
} from '../../../constants.js';
import { CanvasTextAreaProps } from '../../../types/canvas-text-area.js';

export const defineTextToRender = (
  name: string,
  truncationMode: TruncationMode,
  textArea: CanvasTextAreaProps,
  contentType: 'value' | 'label' = 'label',
) =>
  truncateText(name, truncationMode, (truncatedText: string) => {
    const { boxX, boxWidth } = getHorizontalMeasurements(
      truncatedText,
      textArea.x - textArea.width / 2,
      `${
        contentType === 'label'
          ? HONEYCOMB_LABEL_FONT_SIZE
          : HONEYCOMB_VALUE_LABEL_FONT_SIZE
      }px`,
    );

    return isInHorizontalBounds(
      boxX,
      boxWidth,
      textArea.x + textArea.width / 2,
    );
  });
